module.exports = __webpack_public_path__ + "assets/img/ts-2.899aef04.png";